module.exports = __webpack_public_path__ + "images/homepage-ikea-logo.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-ikea-logo.png
// module id = 861
// module chunks = 0